import moment from 'moment';

import { months } from '@pages/WorkSchedule/data';
import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const getInfoByMonth = (startDate?: string) => {
  let date: moment.Moment;

  if (startDate) {
    date = moment(startDate);
  } else {
    date = moment();
  }

  const monthId = date.month();
  const monthInfo = months.find(
    (item: NWorkSchedule.Month) => item.monthId === monthId
  );
  const { monthTitle } = monthInfo!;

  const dateS = date.startOf('month').format('YYYY-MM-DD');
  const dateE = date.endOf('month').format('YYYY-MM-DD');

  const daysRange: string[] = [];
  const daysInMonth = date.daysInMonth();
  for (let i = 1; i <= daysInMonth; i++) {
    daysRange.push(date.date(i).format('YYYY-MM-DD'));
  }

  return {
    title: monthTitle,
    dateS,
    dateE,
    daysRange,
  };
};
